import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext();

export function ChatProvider({ children }) {
  const [externalChat, setExternalChat] = useState(null);

  return (
    <ChatContext.Provider value={{ externalChat, setExternalChat }}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChat() {
  return useContext(ChatContext);
} 